module.exports = __webpack_public_path__ + "static/media/ic_info-blue.2f87149b.svg";